module.exports = __webpack_public_path__ + "img/facebook-f.accda3dd.svg";